// Machine-translated content for Orb Holdings Limited.
// Proper nouns (Orb, The Orb, Orb Holdings Limited, Orb Tech, IO, email, address) are intentionally kept untranslated.

export const LOCALES = [
  { code: "ENG", name: "English (UK)", locale: "en", dir: "ltr" },
  { code: "عربي", name: "Arabic", locale: "ar", dir: "rtl" },
  { code: "FRA", name: "French", locale: "fr", dir: "ltr" },
  { code: "ESP", name: "Spanish", locale: "es", dir: "ltr" },
  { code: "DEU", name: "German", locale: "de", dir: "ltr" },
  { code: "简体", name: "Simplified Chinese", locale: "zh", dir: "ltr" },
];

export const translations = {
  en: {
    nav: { menu: "Menu", betaSignup: "BETA Sign Up" },
    menu: {
      close: "Close",
      overview: "Overview",
      philosophy: "Philosophy — AI, QI, AR & Web3",
      orbtech: "Orb Tech & IO",
      contact: "Contact",
    },
    hero: { tagline: "Reimagining Intelligence", scroll: "Scroll" },
    sections: { overview: "Overview", philosophy: "Philosophy", orbtech: "Orb Tech & IO", contact: "Contact" },
    overview: {
      headA: "Reimagining",
      headB: "Intelligence",
      p1: "Orb Holdings Limited is the parent company supporting a growing portfolio of technology ventures focused on artificial intelligence, spatial computing and human-centred innovation.",
      p2: "Our role is to facilitate the creation and long-term development of transformative technologies through strategic funding, research and development, operational support and real-world implementation.",
      p3: "We provide the structure, resources and direction that allow our companies to turn ambitious ideas into enduring technology businesses.",
    },
    philosophy: {
      headA: "Technology should understand the world as people",
      headB: "experience it.",
      i1: "At Orb, intelligence is not confined to software.",
      i2: "We believe the next generation of computing will understand movement, space, intention and context as naturally as people do.",
      i3: "Artificial Intelligence is only one part of that journey.",
      i4: "As computing evolves, Orb will continuously explore emerging technologies — including Quantum Intelligence, Augmented Reality and decentralized infrastructure — where they meaningfully advance our mission.",
      constant: "Our philosophy remains constant",
      p1: "Build technologies that are intelligent.",
      p2: "Build them responsibly.",
      p3: "Build them for the long term.",
    },
    orbtech: {
      headA: "Building intelligence for the",
      headB: "physical world.",
      tagTech: "TECHNOLOGY COMPANY",
      tagProduct: "FLAGSHIP PRODUCT",
      bodyTech: "Orb Tech is the technology company responsible for research, engineering and commercialization across the Orb ecosystem. Its focus is the development of intelligent platforms that bridge AI with the physical world.",
      bodyIO: "IO is Orb Tech's flagship product. An AI-powered Spatial Intelligence platform that enables infrastructure-free indoor navigation and contextual guidance across complex environments. Designed for businesses and consumers alike, IO represents the first step toward a broader ecosystem of intelligent assistants capable of understanding where people are, where they are going and what they need next.",
      ctaTech: "Visit Orb Tech",
      ctaIO: "Visit IO",
    },
    contact: {
      headA: "Let's shape what",
      headB: "comes next.",
      intro: "For investment, strategic partnerships, research collaborations and corporate enquiries:",
      registered: "Registered Office",
    },
    marquee: ["Artificial Intelligence", "Spatial Computing", "Quantum Intelligence", "Augmented Reality"],
    footer: {
      headA: "Reimagining",
      headB: "Intelligence.",
      getInTouch: "Get in touch",
      navigate: "Navigate",
      ventures: "Ventures",
      contact: "Contact",
      rights: "All rights reserved",
      london: "London, United Kingdom",
    },
  },

  fr: {
    nav: { menu: "Menu", betaSignup: "Inscription BÊTA" },
    menu: {
      close: "Fermer",
      overview: "Aperçu",
      philosophy: "Philosophie — IA, IQ, RA et Web3",
      orbtech: "Orb Tech & IO",
      contact: "Contact",
    },
    hero: { tagline: "Réinventer l'intelligence", scroll: "Défiler" },
    sections: { overview: "Aperçu", philosophy: "Philosophie", orbtech: "Orb Tech & IO", contact: "Contact" },
    overview: {
      headA: "Réinventer",
      headB: "l'intelligence",
      p1: "Orb Holdings Limited est la société mère qui soutient un portefeuille croissant d'entreprises technologiques axées sur l'intelligence artificielle, l'informatique spatiale et l'innovation centrée sur l'humain.",
      p2: "Notre rôle est de faciliter la création et le développement à long terme de technologies transformatrices grâce à un financement stratégique, à la recherche et au développement, au soutien opérationnel et à la mise en œuvre concrète.",
      p3: "Nous fournissons la structure, les ressources et l'orientation qui permettent à nos entreprises de transformer des idées ambitieuses en entreprises technologiques durables.",
    },
    philosophy: {
      headA: "La technologie devrait comprendre le monde tel que les gens",
      headB: "le vivent.",
      i1: "Chez Orb, l'intelligence ne se limite pas au logiciel.",
      i2: "Nous pensons que la prochaine génération d'informatique comprendra le mouvement, l'espace, l'intention et le contexte aussi naturellement que les humains.",
      i3: "L'intelligence artificielle n'est qu'une partie de ce parcours.",
      i4: "À mesure que l'informatique évolue, Orb explorera continuellement les technologies émergentes — notamment l'intelligence quantique, la réalité augmentée et les infrastructures décentralisées — lorsqu'elles font véritablement progresser notre mission.",
      constant: "Notre philosophie reste constante",
      p1: "Créer des technologies intelligentes.",
      p2: "Les créer de manière responsable.",
      p3: "Les créer pour le long terme.",
    },
    orbtech: {
      headA: "Bâtir l'intelligence pour le",
      headB: "monde physique.",
      tagTech: "SOCIÉTÉ TECHNOLOGIQUE",
      tagProduct: "PRODUIT PHARE",
      bodyTech: "Orb Tech est la société technologique responsable de la recherche, de l'ingénierie et de la commercialisation au sein de l'écosystème Orb. Elle se concentre sur le développement de plateformes intelligentes qui relient l'IA au monde physique.",
      bodyIO: "IO est le produit phare d'Orb Tech. Une plateforme d'intelligence spatiale alimentée par l'IA qui permet une navigation intérieure sans infrastructure et un guidage contextuel dans des environnements complexes. Conçu aussi bien pour les entreprises que pour les particuliers, IO représente la première étape vers un écosystème plus vaste d'assistants intelligents capables de comprendre où se trouvent les personnes, où elles vont et ce dont elles ont besoin ensuite.",
      ctaTech: "Visiter Orb Tech",
      ctaIO: "Visiter IO",
    },
    contact: {
      headA: "Façonnons ensemble",
      headB: "la suite.",
      intro: "Pour les investissements, les partenariats stratégiques, les collaborations de recherche et les demandes d'entreprise :",
      registered: "Siège social",
    },
    marquee: ["Intelligence artificielle", "Informatique spatiale", "Intelligence quantique", "Réalité augmentée"],
    footer: {
      headA: "Réinventer",
      headB: "l'intelligence.",
      getInTouch: "Nous contacter",
      navigate: "Naviguer",
      ventures: "Entreprises",
      contact: "Contact",
      rights: "Tous droits réservés",
      london: "Londres, Royaume-Uni",
    },
  },

  es: {
    nav: { menu: "Menú", betaSignup: "Registro BETA" },
    menu: {
      close: "Cerrar",
      overview: "Resumen",
      philosophy: "Filosofía — IA, IC, RA y Web3",
      orbtech: "Orb Tech & IO",
      contact: "Contacto",
    },
    hero: { tagline: "Reimaginando la inteligencia", scroll: "Desplázate" },
    sections: { overview: "Resumen", philosophy: "Filosofía", orbtech: "Orb Tech & IO", contact: "Contacto" },
    overview: {
      headA: "Reimaginar",
      headB: "la inteligencia",
      p1: "Orb Holdings Limited es la empresa matriz que respalda una creciente cartera de proyectos tecnológicos centrados en la inteligencia artificial, la computación espacial y la innovación centrada en las personas.",
      p2: "Nuestra función es facilitar la creación y el desarrollo a largo plazo de tecnologías transformadoras mediante financiación estratégica, investigación y desarrollo, apoyo operativo e implementación en el mundo real.",
      p3: "Proporcionamos la estructura, los recursos y la dirección que permiten a nuestras empresas convertir ideas ambiciosas en negocios tecnológicos duraderos.",
    },
    philosophy: {
      headA: "La tecnología debería entender el mundo como lo",
      headB: "viven las personas.",
      i1: "En Orb, la inteligencia no se limita al software.",
      i2: "Creemos que la próxima generación de la computación entenderá el movimiento, el espacio, la intención y el contexto con la misma naturalidad que las personas.",
      i3: "La inteligencia artificial es solo una parte de ese camino.",
      i4: "A medida que la computación evolucione, Orb explorará continuamente las tecnologías emergentes —incluidas la inteligencia cuántica, la realidad aumentada y la infraestructura descentralizada— cuando impulsen de forma significativa nuestra misión.",
      constant: "Nuestra filosofía permanece constante",
      p1: "Crear tecnologías inteligentes.",
      p2: "Crearlas de forma responsable.",
      p3: "Crearlas a largo plazo.",
    },
    orbtech: {
      headA: "Construyendo inteligencia para el",
      headB: "mundo físico.",
      tagTech: "EMPRESA TECNOLÓGICA",
      tagProduct: "PRODUCTO ESTRELLA",
      bodyTech: "Orb Tech es la empresa tecnológica responsable de la investigación, la ingeniería y la comercialización en todo el ecosistema Orb. Su enfoque es el desarrollo de plataformas inteligentes que conectan la IA con el mundo físico.",
      bodyIO: "IO es el producto estrella de Orb Tech. Una plataforma de inteligencia espacial impulsada por IA que permite la navegación en interiores sin infraestructura y la orientación contextual en entornos complejos. Diseñado tanto para empresas como para consumidores, IO representa el primer paso hacia un ecosistema más amplio de asistentes inteligentes capaces de entender dónde están las personas, adónde van y qué necesitan a continuación.",
      ctaTech: "Visitar Orb Tech",
      ctaIO: "Visitar IO",
    },
    contact: {
      headA: "Demos forma a",
      headB: "lo que viene.",
      intro: "Para inversiones, alianzas estratégicas, colaboraciones de investigación y consultas corporativas:",
      registered: "Domicilio social",
    },
    marquee: ["Inteligencia artificial", "Computación espacial", "Inteligencia cuántica", "Realidad aumentada"],
    footer: {
      headA: "Reimaginar",
      headB: "la inteligencia.",
      getInTouch: "Ponte en contacto",
      navigate: "Navegar",
      ventures: "Empresas",
      contact: "Contacto",
      rights: "Todos los derechos reservados",
      london: "Londres, Reino Unido",
    },
  },

  de: {
    nav: { menu: "Menü", betaSignup: "BETA-Anmeldung" },
    menu: {
      close: "Schließen",
      overview: "Überblick",
      philosophy: "Philosophie — KI, QI, AR & Web3",
      orbtech: "Orb Tech & IO",
      contact: "Kontakt",
    },
    hero: { tagline: "Intelligenz neu gedacht", scroll: "Scrollen" },
    sections: { overview: "Überblick", philosophy: "Philosophie", orbtech: "Orb Tech & IO", contact: "Kontakt" },
    overview: {
      headA: "Intelligenz",
      headB: "neu gedacht",
      p1: "Orb Holdings Limited ist die Muttergesellschaft, die ein wachsendes Portfolio von Technologieunternehmen unterstützt, die sich auf künstliche Intelligenz, räumliches Computing und menschenzentrierte Innovation konzentrieren.",
      p2: "Unsere Aufgabe ist es, die Entstehung und langfristige Weiterentwicklung transformativer Technologien durch strategische Finanzierung, Forschung und Entwicklung, operative Unterstützung und praxisnahe Umsetzung zu ermöglichen.",
      p3: "Wir bieten die Struktur, die Ressourcen und die Ausrichtung, die es unseren Unternehmen ermöglichen, ehrgeizige Ideen in beständige Technologieunternehmen zu verwandeln.",
    },
    philosophy: {
      headA: "Technologie sollte die Welt so verstehen, wie Menschen",
      headB: "sie erleben.",
      i1: "Bei Orb ist Intelligenz nicht auf Software beschränkt.",
      i2: "Wir glauben, dass die nächste Generation des Computings Bewegung, Raum, Absicht und Kontext so natürlich verstehen wird wie Menschen.",
      i3: "Künstliche Intelligenz ist nur ein Teil dieser Reise.",
      i4: "Mit der Weiterentwicklung des Computings wird Orb kontinuierlich neue Technologien erkunden – darunter Quantenintelligenz, Augmented Reality und dezentrale Infrastruktur –, wo sie unsere Mission wirklich voranbringen.",
      constant: "Unsere Philosophie bleibt konstant",
      p1: "Technologien entwickeln, die intelligent sind.",
      p2: "Sie verantwortungsvoll entwickeln.",
      p3: "Sie langfristig entwickeln.",
    },
    orbtech: {
      headA: "Intelligenz für die",
      headB: "physische Welt bauen.",
      tagTech: "TECHNOLOGIEUNTERNEHMEN",
      tagProduct: "FLAGGSCHIFF-PRODUKT",
      bodyTech: "Orb Tech ist das Technologieunternehmen, das für Forschung, Entwicklung und Kommerzialisierung im gesamten Orb-Ökosystem verantwortlich ist. Sein Schwerpunkt liegt auf der Entwicklung intelligenter Plattformen, die KI mit der physischen Welt verbinden.",
      bodyIO: "IO ist das Flaggschiff-Produkt von Orb Tech. Eine KI-gestützte Plattform für räumliche Intelligenz, die eine infrastrukturfreie Innennavigation und kontextbezogene Führung in komplexen Umgebungen ermöglicht. IO wurde für Unternehmen und Verbraucher gleichermaßen entwickelt und stellt den ersten Schritt zu einem umfassenderen Ökosystem intelligenter Assistenten dar, die verstehen, wo sich Menschen befinden, wohin sie gehen und was sie als Nächstes benötigen.",
      ctaTech: "Orb Tech besuchen",
      ctaIO: "IO besuchen",
    },
    contact: {
      headA: "Gestalten wir,",
      headB: "was als Nächstes kommt.",
      intro: "Für Investitionen, strategische Partnerschaften, Forschungskooperationen und Unternehmensanfragen:",
      registered: "Eingetragener Firmensitz",
    },
    marquee: ["Künstliche Intelligenz", "Räumliches Computing", "Quantenintelligenz", "Augmented Reality"],
    footer: {
      headA: "Intelligenz",
      headB: "neu gedacht.",
      getInTouch: "Kontakt aufnehmen",
      navigate: "Navigation",
      ventures: "Unternehmen",
      contact: "Kontakt",
      rights: "Alle Rechte vorbehalten",
      london: "London, Vereinigtes Königreich",
    },
  },

  ar: {
    nav: { menu: "القائمة", betaSignup: "التسجيل التجريبي" },
    menu: {
      close: "إغلاق",
      overview: "نظرة عامة",
      philosophy: "الفلسفة — الذكاء الاصطناعي، الذكاء الكمي، الواقع المعزز و Web3",
      orbtech: "Orb Tech و IO",
      contact: "اتصل بنا",
    },
    hero: { tagline: "إعادة تصوّر الذكاء", scroll: "مرّر" },
    sections: { overview: "نظرة عامة", philosophy: "الفلسفة", orbtech: "Orb Tech و IO", contact: "اتصل بنا" },
    overview: {
      headA: "إعادة تصوّر",
      headB: "الذكاء",
      p1: "شركة Orb Holdings Limited هي الشركة الأم التي تدعم محفظة متنامية من المشاريع التقنية التي تركز على الذكاء الاصطناعي والحوسبة المكانية والابتكار المتمحور حول الإنسان.",
      p2: "يتمثل دورنا في تسهيل ابتكار التقنيات التحويلية وتطويرها على المدى الطويل من خلال التمويل الاستراتيجي والبحث والتطوير والدعم التشغيلي والتنفيذ في العالم الحقيقي.",
      p3: "نحن نوفّر الهيكل والموارد والتوجيه الذي يتيح لشركاتنا تحويل الأفكار الطموحة إلى شركات تقنية دائمة.",
    },
    philosophy: {
      headA: "ينبغي أن تفهم التكنولوجيا العالم كما",
      headB: "يختبره الناس.",
      i1: "في Orb، لا يقتصر الذكاء على البرمجيات.",
      i2: "نؤمن بأن الجيل القادم من الحوسبة سيفهم الحركة والمكان والنية والسياق بالسهولة نفسها التي يفهمها بها البشر.",
      i3: "الذكاء الاصطناعي ليس سوى جزء واحد من هذه الرحلة.",
      i4: "مع تطوّر الحوسبة، ستواصل Orb استكشاف التقنيات الناشئة — بما في ذلك الذكاء الكمي والواقع المعزز والبنية التحتية اللامركزية — حيثما تسهم بشكل حقيقي في تعزيز مهمتنا.",
      constant: "تظل فلسفتنا ثابتة",
      p1: "بناء تقنيات ذكية.",
      p2: "بناؤها بمسؤولية.",
      p3: "بناؤها على المدى الطويل.",
    },
    orbtech: {
      headA: "بناء الذكاء من أجل",
      headB: "العالم المادي.",
      tagTech: "شركة تكنولوجيا",
      tagProduct: "المنتج الرئيسي",
      bodyTech: "Orb Tech هي شركة التكنولوجيا المسؤولة عن البحث والهندسة والتسويق التجاري عبر منظومة Orb. ينصبّ تركيزها على تطوير منصات ذكية تربط الذكاء الاصطناعي بالعالم المادي.",
      bodyIO: "IO هو المنتج الرئيسي لشركة Orb Tech. منصة ذكاء مكاني مدعومة بالذكاء الاصطناعي تتيح التنقل الداخلي دون بنية تحتية والإرشاد السياقي عبر البيئات المعقدة. صُمم IO للشركات والمستهلكين على حد سواء، ويمثل الخطوة الأولى نحو منظومة أوسع من المساعدين الأذكياء القادرين على فهم أين يوجد الناس وإلى أين يتجهون وما يحتاجون إليه لاحقًا.",
      ctaTech: "زيارة Orb Tech",
      ctaIO: "زيارة IO",
    },
    contact: {
      headA: "لنصنع معًا",
      headB: "ما هو قادم.",
      intro: "للاستثمار والشراكات الاستراتيجية والتعاون البحثي والاستفسارات المؤسسية:",
      registered: "المكتب المسجل",
    },
    marquee: ["الذكاء الاصطناعي", "الحوسبة المكانية", "الذكاء الكمي", "الواقع المعزز"],
    footer: {
      headA: "إعادة تصوّر",
      headB: "الذكاء.",
      getInTouch: "تواصل معنا",
      navigate: "التنقل",
      ventures: "الشركات",
      contact: "اتصل بنا",
      rights: "جميع الحقوق محفوظة",
      london: "لندن، المملكة المتحدة",
    },
  },

  zh: {
    nav: { menu: "菜单", betaSignup: "测试版注册" },
    menu: {
      close: "关闭",
      overview: "概览",
      philosophy: "理念 — AI、QI、AR 与 Web3",
      orbtech: "Orb Tech 与 IO",
      contact: "联系",
    },
    hero: { tagline: "重新构想智能", scroll: "向下滚动" },
    sections: { overview: "概览", philosophy: "理念", orbtech: "Orb Tech 与 IO", contact: "联系" },
    overview: {
      headA: "重新构想",
      headB: "智能",
      p1: "Orb Holdings Limited 是一家母公司，支持着一系列不断壮大的科技企业，专注于人工智能、空间计算和以人为本的创新。",
      p2: "我们的职责是通过战略投资、研发、运营支持和实际落地，推动变革性技术的诞生与长期发展。",
      p3: "我们提供结构、资源和方向，使旗下公司能够将雄心勃勃的构想转化为持久的科技企业。",
    },
    philosophy: {
      headA: "科技应当像人们所体验的那样",
      headB: "理解世界。",
      i1: "在 Orb，智能并不局限于软件。",
      i2: "我们相信，下一代计算将像人类一样自然地理解运动、空间、意图与情境。",
      i3: "人工智能只是这一旅程的一部分。",
      i4: "随着计算的发展，Orb 将持续探索新兴技术——包括量子智能、增强现实和去中心化基础设施——只要它们能切实推进我们的使命。",
      constant: "我们的理念始终如一",
      p1: "打造智能的技术。",
      p2: "以负责任的方式打造。",
      p3: "为长远而打造。",
    },
    orbtech: {
      headA: "为物理世界",
      headB: "构建智能。",
      tagTech: "科技公司",
      tagProduct: "旗舰产品",
      bodyTech: "Orb Tech 是负责 Orb 生态系统中研究、工程和商业化的科技公司。其重点是开发将人工智能与物理世界相连接的智能平台。",
      bodyIO: "IO 是 Orb Tech 的旗舰产品。这是一个由人工智能驱动的空间智能平台，可在复杂环境中实现无需基础设施的室内导航和情境化引导。IO 面向企业和消费者，代表着迈向更广泛智能助手生态系统的第一步——这些助手能够理解人们身处何地、将要前往何处以及接下来需要什么。",
      ctaTech: "访问 Orb Tech",
      ctaIO: "访问 IO",
    },
    contact: {
      headA: "共同塑造",
      headB: "未来。",
      intro: "如需投资、战略合作、研究协作及企业咨询：",
      registered: "注册办公地址",
    },
    marquee: ["人工智能", "空间计算", "量子智能", "增强现实"],
    footer: {
      headA: "重新构想",
      headB: "智能。",
      getInTouch: "联系我们",
      navigate: "导航",
      ventures: "企业",
      contact: "联系",
      rights: "版权所有",
      london: "英国伦敦",
    },
  },
};
